import tracr from 'tracr-sdk'

const { sendEvent } = tracr.Events

const trackEvents = {
  formInteracted: ({ cnpj = '', name = '', email = '', phone = '' }) => {
    const payload = {
      cnpj,
      name,
      phone,
      mail: email
    }

    sendEvent('equifax.FormInteracted', payload)
  },
  nps: (payload) => {
    sendEvent('equifax.NPS', { ...payload, grade: Number(payload.grade) })
  }
}

export const triggerTracrTrack = (name, data) => {
  if (name in trackEvents) {
    const event = trackEvents[name]
    return event(data)
  } else {
    const error = new Error(`[@analytics] ${name} does not exit in events`)

    return Promise.reject(error)
  }
}
